export default __webpack_public_path__ + "static/media/slider_3-sm@2x.cc72a3cf.jpg";